module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = 165
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16